import React from 'react';
import PropTypes from 'prop-types';

import { DropdownButton, MenuItem } from 'react-bootstrap';
import capitalize from 'lodash/capitalize';

import StageSelect from 'bundles/apex/stage_select';

function CopyTaskSelects({ dealType, dealTypeOptions, label, stage, stages, onDealTypeChange, onStageChange }) {
  return (
    <div className="copy-tasks-selects">
      <h3 className="copy-tasks-selects-label m-0">{label}</h3>
      <DropdownButton
        bsSize="small"
        className="ml-1"
        id="deal-type-dropdown"
        title={dealTypeOptions.find(dealTypeOption => dealTypeOption.value === dealType)?.label}
      >
        {dealTypeOptions.map(dealTypeOption => (
          <MenuItem
            key={dealTypeOption.value}
            name={dealTypeOption.value}
            onClick={() => onDealTypeChange(dealTypeOption.value)}
          >
            {capitalize(dealTypeOption.label)}
          </MenuItem>
        ))}
      </DropdownButton>
      <StageSelect setStage={onStageChange} stage={stage} stages={stages} />
    </div>
  );
}

CopyTaskSelects.propTypes = {
  dealType: PropTypes.string.isRequired,
  dealTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  label: PropTypes.string.isRequired,
  stage: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  stages: PropTypes.object,
  onDealTypeChange: PropTypes.func.isRequired,
  onStageChange: PropTypes.func.isRequired,
};

export default CopyTaskSelects;